import { createClient } from '@supabase/supabase-js'
import { config } from '../config/env'

// Validate Supabase configuration
if (!config.SUPABASE_URL) {
  console.error('❌ REACT_APP_SUPABASE_URL is missing. Got:', config.SUPABASE_URL)
  console.error('Environment:', process.env.NODE_ENV)
  console.error('All REACT_APP vars:', Object.keys(process.env).filter(k => k.startsWith('REACT_APP_')))
  throw new Error('REACT_APP_SUPABASE_URL environment variable is required')
}

if (!config.SUPABASE_ANON_KEY) {
  console.error('❌ REACT_APP_SUPABASE_ANON_KEY is missing. Got:', config.SUPABASE_ANON_KEY)
  console.error('Environment:', process.env.NODE_ENV)
  console.error('All REACT_APP vars:', Object.keys(process.env).filter(k => k.startsWith('REACT_APP_')))
  throw new Error('REACT_APP_SUPABASE_ANON_KEY environment variable is required')
}


// Production-ready Supabase client with auth configuration
export const supabase = createClient(config.SUPABASE_URL, config.SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

// Helper function to get the correct redirect URL for the current environment
export const getRedirectUrl = () => {
  if (typeof window === 'undefined') return 'http://localhost:3000'
  
  return process.env.NODE_ENV === 'production' 
    ? window.location.origin 
    : 'http://localhost:3000'
}

// Helper function for sign in with redirect
export const signInWithProvider = async (provider: 'google' | 'github' | 'facebook') => {
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider,
    options: {
      redirectTo: getRedirectUrl()
    }
  })
  return { data, error }
}